import {useQuery} from "react-query";
import axios from "axios";

const apiUrl = "api/audit/command-history/by-power-station";

export interface PowerStationCommandCount {
    powerStationId: number;
    powerStationName: string;
    count: number;
}

const fetchCommandCountByPowerStation = async (
    startDateTime: string | null,
    endDateTime: string | null,
    powerStationIds?: number[] | null
): Promise<PowerStationCommandCount[]> => {
    try {
        const params = new URLSearchParams();
        if (startDateTime) params.append("startDateTime", startDateTime);
        if (endDateTime) params.append("endDateTime", endDateTime);
        if (powerStationIds && powerStationIds.length > 0) {
            powerStationIds.forEach((id) => params.append("powerStationIds", String(id)));
        }
        const response = await axios.get(apiUrl, {params, timeout: 30000});
        return response.data ?? [];
    } catch (error) {
        console.error("Error fetching command count by power station:", error);
        return [];
    }
};

export const CommandCountByPowerStationReactQuery = (
    startDateTime: string | null,
    endDateTime: string | null,
    enabled: boolean = true,
    powerStationIds?: number[] | null
) => {
    return useQuery({
        queryKey: ["command-count-by-power-station", startDateTime, endDateTime, powerStationIds],
        queryFn: () => fetchCommandCountByPowerStation(startDateTime, endDateTime, powerStationIds),
        enabled: enabled && !!startDateTime && !!endDateTime,
    });
};
